
<div *ngIf="loaderService?.isLoading | async" class="MatSpinner">
  <div class="MatSpinner-container">
    <mat-spinner></mat-spinner>
  </div>
</div>
<main-navigation *ngIf="!isExcludedRoute()"></main-navigation>

<icullen-account-warning></icullen-account-warning>

<router-outlet></router-outlet>
<!-- <div class="Error">
  <div class="Wrap">
    <div class="Content">
      <div class="Error-container">
        <div class="row">
          <div class="col-lg-9">
            <div class="row">
              <div class="col-md-6">
                <div class="SvgBox SvgBox--Connection">
                  <svg xmlns="http://www.w3.org/2000/svg" width="500" height="480" viewBox="0 0 500 480">
                    <path class="Circle" style="fill:#0099a1;" d="M275.4,329.5c-0.4,14-12,25-25.7,24.6c-14-0.4-25.1-11.9-24.6-25.7c0.5-14,12-25,25.7-24.6
                      C264.8,304.3,275.8,315.8,275.4,329.5z"/>

                    <path class="Wave_1" style="fill:#0099a1;" d="M356.7,246.9c-11.8,11.8-23.4,23.5-35.3,35.4c-19.8-18.8-43.5-29.1-71.1-29.1c-27.6,0-51.3,10.2-71,29
                      c-11.9-12-23.6-23.7-35.3-35.5C199.2,189.2,298.2,186.9,356.7,246.9z"/>
                    <path class="Wave_2" style="fill:#0099a1;" d="M107.5,210.7c-12-12-23.6-23.5-35.7-35.6c48.2-46.7,105.6-72,172.9-73.3c71.4-1.4,132.5,23.8,183.8,73.2
                      c-12.1,12.1-23.8,23.7-35.7,35.6c-39.7-38-87.2-58.5-142.5-58.6C194.9,152.1,147.4,172.5,107.5,210.7z"/>
                    <path class="Wave_3" style="fill:#0099a1;" d="M0,103.7c7.9-7.1,15.6-14.4,23.8-21.3c24.3-20.4,50.9-37.1,79.8-50.3c19.7-9,40-16.1,61-21.3
                      C206.7,0.4,249.5-2,292.6,3c33.2,3.8,65.1,12.4,95.8,25.4c29.6,12.5,57,28.7,82,49c10.2,8.3,19.9,17.2,29.6,25.6
                      c-12.2,12.2-24,23.9-36,35.9C404.9,81.6,333.5,51.1,250.3,51C167,51,95.6,81.5,35.6,139.7c-9.1-9.2-17.9-18.2-26.9-27.1
                      c-2.8-2.8-5.8-5.4-8.7-8.1C0,104.3,0,104,0,103.7z"/>
                  </svg>
                </div>
              </div>
              <div class="col-md-6">
                <div class="Text">
                  <h2>Problem with your connection</h2>
                  <p>
                    You are having difficulty connecting to the Web.<br>
                    Please check your connection or try again later.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->
<cullen-footer *ngIf="!isExcludedRoute()"></cullen-footer>
<app-version-info></app-version-info>
